import script from "./indexPage.vue?vue&type=script&setup=true&lang=js"
export * from "./indexPage.vue?vue&type=script&setup=true&lang=js"

import "./indexPage.vue?vue&type=style&index=0&id=75d08860&scoped=true&lang=scss"

import exportComponent from "D:\\liu\\jmzc\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75d08860"]])

export default __exports__